// Single source of truth for the Firebase Web/Browser ("platform") API keys
// — the public `AIza…` strings used for Firebase Auth. These are NOT secrets
// in the rotation sense: the same value ships inside every published client
// bundle. What protects them is the per-key API allow-list on the GCP API
// Keys page (Auth-only: identitytoolkit + securetoken), NOT secrecy. See
// design-docs/secrets-inventory.md "Firebase Platform API Keys" before
// widening either key's allow-list.
//
// Why this module exists (#3818 follow-up): the admin CLI
// (tools/src/firebase-cmd.ts) needs this key to exchange a custom token for
// an ID token (Identity Toolkit signInWithCustomToken) when it deletes a user
// through the server callable. It used to read the key from a separate
// .secrets/<env>/firebase-service-apikey.txt file, which silently drifted out
// of date and broke `user:delete` with "API key expired". Keeping the value
// in ONE checked-in place that both the client config and the CLI import means
// the two can never disagree again.
export const FIREBASE_WEB_API_KEY_DEV = 'AIzaSyAaUQGNlHNVDnFANxQaTfEi4LAmeaedLpI';
export const FIREBASE_WEB_API_KEY_PROD = 'AIzaSyByVscxOvhEFe78edGWi1AOferwCDMAWJk';

// keyed lookup for env-parameterised callers (e.g. the admin CLI's --env).
export const FIREBASE_WEB_API_KEYS = {
  dev: FIREBASE_WEB_API_KEY_DEV,
  prod: FIREBASE_WEB_API_KEY_PROD,
} as const;
